// extracted by mini-css-extract-plugin
module.exports = {"modal":"FillYourInfoModal_modal__xUeB2"};